export const DEFAULT_PRESET_SET = 'DEFAULT_PRESET_SET';
export const defaultPresetSet = (key, properties) => ({ type: DEFAULT_PRESET_SET, payload: { key, properties } });
